<div class="d-flex flex-column h-100">
    <div class="flex-grow-1 overflow-auto">
        <div class="w-100 p-3">
            <div class="header mb-3">
                <div class="container-fluid">
                    <div class="row d-flex align-items-center solar-card">
                        <div class="col-auto px-0 text-center">
                            <span class="fa-stack">
                                <i class="fa fa-circle-thin fa-stack-2x"></i>
                                <i class="fa fa-info fa-stack-1x"></i>
                            </span>
                        </div>
                        <div class="col">
                            Pour simuler vos besoins en eau chaude, nous avons besoin de connaître
                            votre consommation. Merci de préciser le nombre d’occupants dans votre
                            logement<ng-container *ngIf="shouldAddIncomeBracket">
                                et de préciser la tranche de revenus du ménage </ng-container
                            >.
                        </div>
                    </div>
                </div>
            </div>

            <div class="body">
                <div class="container-fluid solar-card building-description">
                    <h5 class="text-st-primary mb-3">Je décris mon bâtiment</h5>

                    <form [formGroup]="formGroup">
                        <div class="row d-flex align-items-center">
                            <label
                                for="occupant-count"
                                class="col-sm control-label text-start fw-normal"
                            >
                                Nombre d'occupants
                            </label>
                            <div class="col-sm-5">
                                <stInput
                                    formControlName="occupantCount"
                                    innerId="occupant-count"
                                    class="primary"
                                    type="number"
                                    [min]="1"
                                    [step]="1"
                                    [isInvalid]="occupantCountControl?.invalid"
                                >
                                </stInput>
                            </div>
                        </div>

                        @if (shouldAddIncomeBracket) {
                        <div class="row d-flex align-items-center">
                            <label
                                for="incomeBracket"
                                class="col-sm control-label text-start fw-normal py-0"
                            >
                                Tranche de revenus
                            </label>
                            <div class="col-auto d-flex align-items-center">
                                <stButton
                                    class="btn-info-modal"
                                    btnClass="d-flex align-items-center py-0"
                                    iconLeft="bi bi-info-circle-fill text-st-secondary fs-5"
                                    iconLeftHover="bi bi-info-circle fs-5"
                                    (onClick)="openIncomeInfoModal()"
                                    title="Plus d'information"
                                ></stButton>
                            </div>
                            <div class="col-sm-5">
                                <stSelect
                                    innerId="incomeBracket"
                                    formControlName="incomeBracket"
                                    [data]="incomeBracketOptions"
                                    labelField="label"
                                    valueField="value"
                                    type="primary"
                                    placeholder="Choisissez une tranche de revenus"
                                    [isInvalid]="incomeBracketControl?.invalid"
                                >
                                </stSelect>
                            </div>
                        </div>
                        }
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="footer border-top">
        <div class="container-fluid py-3">
            <div class="row">
                <div class="col-5">
                    <stButton
                        class="btn-st-lg"
                        btnClass="btn-st-default w-100 h-100"
                        btnLabel="Retour"
                        (onClick)="cancel()"
                    >
                    </stButton>
                </div>
                <div class="col-7">
                    <stButton
                        class="btn-st-lg"
                        btnClass="btn-st-primary w-100"
                        btnLabel="Valider les paramètres"
                        [isDisabled]="!isFormValid"
                        (onClick)="validate()"
                    >
                    </stButton>
                </div>
            </div>
        </div>
    </div>
</div>
